module.exports = __webpack_public_path__ + "static/img/icon-04.d443e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/four-pillars/icon-04.png
// module id = lN6P
// module chunks = 1